import { FUN } from "./categories";
import MangaQuiz from "../../public/game-assets/MangaQuiz_icon.png";
import MangaQuizBanner from "../../public/game-assets/banners/MangaQuiz_banner.png";
import { OG_IMAGE_BASE_URL } from "constants/links.const";

export const mangaQuizGame = {
  type: "quiz",
  id: 40,
  game_id: "manga_quiz",
  title: "Manga Quiz",
  description:
    "Welcome to Manga Quiz: The Ultimate Manga Quiz Game! Manga Quiz is a free trivia quiz app with the most entertaining manga quiz questions and answers. Prove that you are a real anime fan with this fun trivia quiz game!",
  pathname: "manga-quiz",
  imageUrl: MangaQuiz,
  categories: [FUN],
  imageAlt: "Manga Quiz Game",
  bannerImageUrl: MangaQuizBanner,
  meta: {
    keywords:
      "manga, quiz questions, quiz game, trivia game, online quiz, fun trivia",
    title:
      "Manga Quiz: The Ultimate Manga Quiz Game | Free Trivia Online Quiz Game",
    description:
      "Welcome to Manga Quiz: The Ultimate Manga Quiz Game! Manga Quiz is a free trivia quiz app with the most entertaining manga quiz questions and answers. Prove that you are a real anime fan with this fun trivia quiz game!",
    image: OG_IMAGE_BASE_URL + "trivia-quiz-game-online-og.jpg",
  },
};

export const mangaQuizQuestions = [
  {
    question: "Who is the creator of the popular manga series 'One Piece'?",
    id: 1,
    options: [
      "Eiichiro Oda",
      "Masashi Kishimoto",
      "Akira Toriyama",
      "Tite Kubo",
    ],
    answer: "Eiichiro Oda",
  },
  {
    question:
      "In the manga 'Naruto,' what is the name of the village where Naruto Uzumaki lives?",
    id: 2,
    options: [
      "Village Hidden in the Mist",
      "Village Hidden in the Clouds",
      "Village Hidden in the Sand",
      "Village Hidden in the Leaves",
    ],
    answer: "Village Hidden in the Leaves",
  },
  {
    question: "The 'Attack on Titan' manga was created by which artist?",
    id: 3,
    options: [
      "Eiichiro Oda",
      "Hajime Isayama",
      "Kohei Horikoshi",
      "Yoshihiro Togashi",
    ],
    answer: "Hajime Isayama",
  },
  {
    question:
      "What is the primary weapon used by demon slayers in the manga 'Demon Slayer: Kimetsu no Yaiba'?",
    id: 4,
    options: ["Swords", "Guns", "Nichirin Blades", "Spears"],
    answer: "Nichirin Blades",
  },
  {
    question:
      "'My Hero Academia' is set in a world where individuals with Quirks aim to become heroes or villains. What's the protagonist's Quirk?",
    id: 5,
    options: ["Invisibility", "One For All", "Super Strength", "Telekinesis"],
    answer: "One For All",
  },
  {
    question:
      "Which manga series features the adventures of Gon Freecss as he searches for his father and becomes a Hunter?",
    id: 6,
    options: ["Naruto", "One Piece", "Hunter x Hunter", "Demon Slayer"],
    answer: "Hunter x Hunter",
  },
  {
    question:
      "'One Punch Man' follows Saitama, a hero who defeats all foes with a single punch. What is his ultimate goal?",
    id: 7,
    options: [
      "Becoming the Strongest Hero",
      "Finding Treasure",
      "Finding a Worthy Opponent",
      "Ruling the World",
    ],
    answer: "Finding a Worthy Opponent",
  },
  {
    question:
      "The protagonist of 'Black Clover,' Asta, aims to become the Wizard King despite lacking what ability?",
    id: 8,
    options: ["Invisibility", "Telekinesis", "Time Travel", "Magic"],
    answer: "Magic",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the mysterious detective known as 'L'?",
    id: 9,
    options: ["Light Yagami", "Ryuk", "Lawliet", "Near"],
    answer: "Lawliet",
  },
  {
    question:
      "The manga 'Noragami' revolves around a minor god named Yato who dreams of what?",
    id: 10,
    options: [
      "Becoming Human",
      "Having a Shrine Dedicated to Him",
      "Defeating Other Gods",
      "Conquering the Spirit World",
    ],
    answer: "Having a Shrine Dedicated to Him",
  },
  {
    question:
      "'Demon Slayer: Kimetsu no Yaiba' centers around a boy named Tanjiro Kamado who fights against demons after his family is slaughtered. What does he wield?",
    id: 11,
    options: ["Bow and Arrows", "Sword", "Whip", "Dagger"],
    answer: "Sword",
  },
  {
    question:
      "In 'Tokyo Ghoul,' what special type of ghouls can use kagune on both sides of their bodies?",
    id: 12,
    options: ["Half-Ghouls", "One-Eyed Ghouls", "Binge Eaters", "Ukaku Ghouls"],
    answer: "One-Eyed Ghouls",
  },
  {
    question:
      "The manga 'Dragon Ball' introduced the concept of the Dragon Balls. How many Dragon Balls are required to summon the Eternal Dragon?",
    id: 13,
    options: ["4", "7", "9", "10"],
    answer: "7",
  },
  {
    question:
      "Which manga series follows Guts, a skilled swordsman, as he seeks revenge on the God Hand and their demonic apostles?",
    id: 14,
    options: ["Berserk", "Fairy Tail", "My Hero Academia", "Attack on Titan"],
    answer: "Berserk",
  },
  {
    question:
      "In 'Death Note' character Misa Amane gains a Death Note and a pair of Shinigami eyes. What can she do with these eyes?",
    id: 15,
    options: [
      "See Through Walls",
      "Predict the Future",
      "See People's Names and Lifespans",
      "Control Other People's Minds",
    ],
    answer: "See People's Names and Lifespans",
  },
  {
    question:
      "In 'One Piece,' what is the name of Luffy's brother, who possesses the power of the Flame-Flame Fruit?",
    id: 16,
    options: ["Ace", "Sabre", "Blaze", "Inferno"],
    answer: "Ace",
  },
  {
    question:
      "The 'My Hero Academia' protagonist, Izuku Midoriya, inherits his Quirk from which hero?",
    id: 17,
    options: ["All Might", "Endeavor", "Best Jeanist", "Hawks"],
    answer: "All Might",
  },
  {
    question:
      "In 'Naruto,' which character has a Sharingan eye and is known for his quest to kill his brother Itachi?",
    id: 18,
    options: [
      "Kakashi Hatake",
      "Sasuke Uchiha",
      "Naruto Uzumaki",
      "Minato Namikaze",
    ],
    answer: "Sasuke Uchiha",
  },
  {
    question:
      "'Attack on Titan' follows Eren Yeager's fight against Titans. What special ability does Eren possess?",
    id: 19,
    options: ["Invisibility", "Time Travel", "Flight", "Titan Shifting"],
    answer: "Titan Shifting",
  },
  {
    question:
      "In the manga 'Tokyo Ghoul,' what is the name of the group that opposes the ghouls and fights to maintain peace?",
    id: 20,
    options: ["Aogiri Tree", "Anteiku", "Doves", "Crows"],
    answer: "Doves",
  },
  {
    question:
      "Who is the main protagonist of the manga 'Dragon Ball' and its various series?",
    id: 21,
    options: ["Vegeta", "Goku", "Piccolo", "Frieza"],
    answer: "Goku",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the older brother's name?",
    id: 22,
    options: ["Edward", "Roy", "Alphonse", "Ling"],
    answer: "Alphonse",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character aspires to find his father, who is a legendary Hunter?",
    id: 23,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Gon Freecss",
  },
  {
    question:
      "'One Punch Man' follows Saitama, a hero who can defeat any opponent with a single punch. What is his primary challenge?",
    id: 24,
    options: [
      "Defeating Monsters",
      "Finding Worthy Opponents",
      "Maintaining His Secret Identity",
      "Controlling His Powers",
    ],
    answer: "Finding Worthy Opponents",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the magical grimoire that Asta receives?",
    id: 25,
    options: [
      "Sorcerer's Tome",
      "Wizard's Codex",
      "Magic Manual",
      "Grimoire of Zero",
    ],
    answer: "Grimoire of Zero",
  },
  {
    question:
      "'Death Note' follows Light Yagami as he uses the Death Note to eliminate criminals. What alias does Light adopt?",
    id: 26,
    options: ["Kira", "L", "Ryuk", "Near"],
    answer: "Kira",
  },
  {
    question:
      "In 'Noragami,' what kind of spirit does the protagonist, Yato, consider himself to be?",
    id: 27,
    options: ["Earth Spirit", "Water Spirit", "War God", "Minor God"],
    answer: "War God",
  },
  {
    question:
      "In 'Dragon Ball Super,' what transformation does Goku achieve that grants him god-like power?",
    id: 28,
    options: [
      "Ultra Instinct",
      "Super Saiyan Blue",
      "Golden Frieza",
      "Super Saiyan God",
    ],
    answer: "Ultra Instinct",
  },
  {
    question:
      "In the manga 'Berserk,' Guts wields a massive sword and is on a quest for revenge. What is the name of his sword?",
    id: 29,
    options: ["Dragon Slayer", "Demonbane", "Soulreaper", "Titan Killer"],
    answer: "Dragon Slayer",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the Shinigami who drops the Death Note into the human world?",
    id: 30,
    options: ["Ryuk", "Rem", "Shinigami", "Misa"],
    answer: "Ryuk",
  },
  {
    question:
      "Which manga series follows the adventures of Monkey D. Luffy as he searches for the legendary treasure 'One Piece'?",
    id: 31,
    options: ["Bleach", "One Piece", "Naruto", "Fairy Tail"],
    answer: "One Piece",
  },
  {
    question:
      "'My Hero Academia' is set in a world where individuals possess Quirks. What's the name of the prestigious academy that trains aspiring heroes?",
    id: 32,
    options: [
      "Hero Academy",
      "Pro Hero Institute",
      "U.A. High School",
      "Heroic Academy",
    ],
    answer: "U.A. High School",
  },
  {
    question:
      "In 'Naruto,' who is the fourth Hokage of the Hidden Leaf Village?",
    id: 33,
    options: ["Minato Namikaze", "Kakashi Hatake", "Jiraiya", "Orochimaru"],
    answer: "Minato Namikaze",
  },
  {
    question:
      "The 'Attack on Titan' manga introduces a group of elite soldiers who fight Titans outside the walls. What are they called?",
    id: 34,
    options: [
      "Garrison Regiment",
      "Scouts Regiment",
      "Military Police Brigade",
      "Warrior Unit",
    ],
    answer: "Scouts Regiment",
  },
  {
    question:
      "In 'Tokyo Ghoul,' ghouls are beings that feed on human flesh. What's the primary method by which ghouls acquire food?",
    id: 35,
    options: [
      "Hunting Animals",
      "Farming Humans",
      "Feeding on Corpses",
      "Attacking Other Ghouls",
    ],
    answer: "Attacking Other Ghouls",
  },
  {
    question:
      "The protagonist of 'Dragon Ball Z' is Gohan. What is his father's name?",
    id: 36,
    options: ["Vegeta", "Krillin", "Piccolo", "Goku"],
    answer: "Goku",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the younger brother's name?",
    id: 37,
    options: ["Edward", "Roy", "Alphonse", "Ling"],
    answer: "Edward",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character is a member of the Zoldyck family of assassins?",
    id: 38,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Killua Zoldyck",
  },
  {
    question:
      "'One Punch Man' features a cyborg hero who seeks revenge on the mad scientist who transformed him. What is this hero's name?",
    id: 39,
    options: ["Genos", "Mumen Rider", "Bang", "King"],
    answer: "Genos",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the demon residing within Asta's grimoire?",
    id: 40,
    options: ["Demon King", "Black Demon", "Amon", "Astaroth"],
    answer: "Amon",
  },
  {
    question:
      "'Death Note' follows Light Yagami as he uses the Death Note to eliminate criminals. What is the purpose of the Shinigami who dropped the Death Note?",
    id: 41,
    options: [
      "To Create Chaos",
      "To Help Humans",
      "To Observe Human Behavior",
      "To Regain His Powers",
    ],
    answer: "To Regain His Powers",
  },
  {
    question:
      "In 'Noragami,' what is the name of Yato's divine weapon partner?",
    id: 42,
    options: ["Yukine", "Kazuma", "Nora", "Bishamon"],
    answer: "Yukine",
  },
  {
    question:
      "In 'Dragon Ball Super,' what transformation allows Goku to achieve power beyond Super Saiyan Blue?",
    id: 43,
    options: [
      "Super Saiyan 4",
      "Ultra Instinct",
      "Golden Frieza",
      "Super Saiyan God",
    ],
    answer: "Ultra Instinct",
  },
  {
    question:
      "The manga 'Berserk' follows Guts on his quest for revenge. What is the name of the mysterious and powerful artifact he possesses?",
    id: 44,
    options: [
      "Eclipse Amulet",
      "Crimson Behelit",
      "Void Crystal",
      "Black Relic",
    ],
    answer: "Crimson Behelit",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the Shinigami who owned the Death Note before dropping it in the human world?",
    id: 45,
    options: ["Ryuk", "Rem", "Shinigami", "Misa"],
    answer: "Ryuk",
  },
  {
    question:
      "Which manga series follows Monkey D. Luffy and his crew of pirates as they search for the legendary treasure 'One Piece'?",
    id: 46,
    options: ["Bleach", "One Piece", "Naruto", "Fairy Tail"],
    answer: "One Piece",
  },
  {
    question:
      "In 'My Hero Academia,' what is the name of the hero who can manipulate and control ice?",
    id: 47,
    options: ["Firestorm", "Frostbite", "Icy Wind", "Shoto Todoroki"],
    answer: "Shoto Todoroki",
  },
  {
    question:
      "In 'Naruto,' who is the Hokage of the Hidden Leaf Village at the beginning of the series?",
    id: 48,
    options: [
      "Minato Namikaze",
      "Tobirama Senju",
      "Hiruzen Sarutobi",
      "Kakashi Hatake",
    ],
    answer: "Hiruzen Sarutobi",
  },
  {
    question:
      "'Attack on Titan' explores the origin of Titans and their connection to the Eldian people. What is the name of the island where the story is primarily set?",
    id: 49,
    options: [
      "Paradis Island",
      "Marley Island",
      "Eldia Island",
      "Titan Island",
    ],
    answer: "Paradis Island",
  },
  {
    question:
      "In 'Tokyo Ghoul,' what is the name of the group that aims to bridge the gap between humans and ghouls?",
    id: 50,
    options: ["Doves", "Aogiri Tree", "Anteiku", "C.C.G."],
    answer: "Anteiku",
  },
  {
    question:
      "The protagonist of 'Dragon Ball Z' is Gohan. What is his mother's name?",
    id: 51,
    options: ["Chi-Chi", "Bulma", "Videl", "Android 18"],
    answer: "Chi-Chi",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the name of their childhood friend?",
    id: 52,
    options: ["Winry Rockbell", "Lust", "May Chang", "Hawkeye"],
    answer: "Winry Rockbell",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character is the last surviving member of the Kurta Clan?",
    id: 53,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Kurapika",
  },
  {
    question:
      "'One Punch Man' features a cyborg hero who seeks revenge on the mad scientist who transformed him. What is the name of this hero's sensei?",
    id: 54,
    options: ["Genos", "Mumen Rider", "Bang", "Saitama"],
    answer: "Bang",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the magic knight squad to which Asta and Yuno belong?",
    id: 55,
    options: ["Crimson Lions", "Black Bulls", "Golden Dawn", "Azure Deer"],
    answer: "Black Bulls",
  },
  {
    question:
      "'Death Note' follows Light Yagami as he uses the Death Note to eliminate criminals. What is the nickname given to him by the public?",
    id: 56,
    options: ["Kira", "L", "Ryuk", "Near"],
    answer: "Kira",
  },
  {
    question:
      "In 'Noragami,' what is the name of the regalia partner of Bishamon, the war god?",
    id: 57,
    options: ["Yukine", "Kazuma", "Nora", "Aiha"],
    answer: "Kazuma",
  },
  {
    question:
      "In 'Dragon Ball Super,' which character is the God of Destruction of Universe 7?",
    id: 58,
    options: ["Beerus", "Champa", "Whis", "Goku"],
    answer: "Beerus",
  },
  {
    question:
      "The manga 'Berserk' follows Guts on his quest for revenge. What is the name of the group of companions who join him?",
    id: 59,
    options: [
      "Band of the Falcon",
      "Guild of Heroes",
      "Order of the Dragon",
      "Coven of Shadows",
    ],
    answer: "Band of the Falcon",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the Shinigami who owns the Death Note that Light finds?",
    id: 60,
    options: ["Ryuk", "Rem", "Shinigami", "Misa"],
    answer: "Ryuk",
  },
  {
    question:
      "Which manga series follows the adventures of Monkey D. Luffy and his crew as they search for the legendary treasure 'One Piece'?",
    id: 61,
    options: ["Bleach", "One Piece", "Naruto", "Fairy Tail"],
    answer: "One Piece",
  },
  {
    question:
      "In 'My Hero Academia,' what is the hero name of Katsuki Bakugou?",
    id: 62,
    options: ["Dynamight", "Flashfire", "Explosion Boy", "Sparky Kats"],
    answer: "Dynamight",
  },
  {
    question: "In 'Naruto,' who is the sensei of Team 7?",
    id: 63,
    options: ["Kakashi Hatake", "Jiraiya", "Orochimaru", "Tsunade"],
    answer: "Kakashi Hatake",
  },
  {
    question:
      "'Attack on Titan' explores the conflict between humanity and the Titans. What are the Titans' true identity?",
    id: 64,
    options: ["Aliens", "Humans with Titan Powers", "Demons", "Giant Animals"],
    answer: "Humans with Titan Powers",
  },
  {
    question:
      "In 'Tokyo Ghoul,' what is the term used to describe ghouls who live without harming humans?",
    id: 65,
    options: [
      "Peaceful Ghouls",
      "Friendly Ghouls",
      "Gourmet Ghouls",
      "Gentle Ghouls",
    ],
    answer: "Gourmet Ghouls",
  },
  {
    question:
      "The protagonist of 'Dragon Ball Z' is Gohan. What is his father's Saiyan name?",
    id: 66,
    options: ["Vegeta", "Raditz", "Goku", "Bardock"],
    answer: "Goku",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the name of the state military unit they join?",
    id: 67,
    options: [
      "Amestris Army",
      "Alchemy Corps",
      "Central Military",
      "State Alchemists",
    ],
    answer: "State Alchemists",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character is a medical student and aspires to become a doctor?",
    id: 68,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Leorio Paradinight",
  },
  {
    question:
      "'One Punch Man' features a cyborg hero who seeks revenge on the mad scientist who transformed him. What is the hero association's highest-ranked hero?",
    id: 69,
    options: ["Genos", "Mumen Rider", "Bang", "Blast"],
    answer: "Blast",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the magical kingdom where Asta and Yuno are from?",
    id: 70,
    options: [
      "Clover Kingdom",
      "Spade Kingdom",
      "Diamond Kingdom",
      "Heart Kingdom",
    ],
    answer: "Clover Kingdom",
  },
  {
    question:
      "'Death Note' follows Light Yagami as he uses the Death Note to eliminate criminals. What is the profession of Light's father?",
    id: 71,
    options: ["Detective", "Lawyer", "Doctor", "News Reporter"],
    answer: "Detective",
  },
  {
    question:
      "In 'Noragami,' what is the name of the goddess of poverty and misfortune?",
    id: 72,
    options: ["Bishamon", "Kofuku", "Tenjin", "Yato"],
    answer: "Kofuku",
  },
  {
    question:
      "In 'Dragon Ball Super,' who is the attendant and martial arts teacher of Beerus, the God of Destruction?",
    id: 73,
    options: ["Vegeta", "Champa", "Whis", "Goku"],
    answer: "Whis",
  },
  {
    question:
      "The manga 'Berserk' follows Guts on his quest for revenge. What is the name of the mysterious group that controls the world's fate?",
    id: 74,
    options: ["God Hand", "Eclipse Cult", "Void Order", "Black Council"],
    answer: "God Hand",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the Shinigami who first owned the Death Note?",
    id: 75,
    options: ["Ryuk", "Rem", "Shinigami", "Misa"],
    answer: "Ryuk",
  },
  {
    question:
      "Which manga series follows the adventures of Monkey D. Luffy as he searches for the legendary treasure 'One Piece'?",
    id: 76,
    options: ["Bleach", "One Piece", "Naruto", "Fairy Tail"],
    answer: "One Piece",
  },
  {
    question:
      "In 'My Hero Academia,' who is known as the 'Symbol of Peace' and is the number one hero?",
    id: 77,
    options: ["Endeavor", "Hawks", "All Might", "Best Jeanist"],
    answer: "All Might",
  },
  {
    question:
      "'Attack on Titan' follows Eren Yeager's fight against Titans. What is the name of Eren's adoptive sister who is kidnapped by human traffickers?",
    id: 79,
    options: [
      "Mikasa Ackerman",
      "Historia Reiss",
      "Sasha Blouse",
      "Annie Leonhart",
    ],
    answer: "Mikasa Ackerman",
  },
  {
    question:
      "In 'Tokyo Ghoul,' ghouls possess a unique organ that allows them to use their powers. What is this organ called?",
    id: 80,
    options: ["Ghoul Core", "Crimson Organ", "Kagune", "Shadow Gland"],
    answer: "Kagune",
  },
  {
    question:
      "The protagonist of 'Dragon Ball Z' is Gohan. What is his mother's Saiyan name?",
    id: 81,
    options: ["Chi-Chi", "Bulma", "Videl", "Android 18"],
    answer: "Chi-Chi",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the name of the alchemical energy source?",
    id: 82,
    options: ["Ether", "Mana", "Prana", "Tectum"],
    answer: "Prana",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character is the assassin who hails from the Zoldyck family?",
    id: 83,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Killua Zoldyck",
  },
  {
    question:
      "'One Punch Man' features a cyborg hero who seeks revenge on the mad scientist who transformed him. What is the name of the Hero Association's top-ranked hero?",
    id: 84,
    options: ["Genos", "Mumen Rider", "Bang", "Blast"],
    answer: "Blast",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the magical kingdom where Asta and Yuno are from?",
    id: 85,
    options: [
      "Clover Kingdom",
      "Spade Kingdom",
      "Diamond Kingdom",
      "Heart Kingdom",
    ],
    answer: "Clover Kingdom",
  },
  {
    question:
      "'Death Note' follows Light Yagami as he uses the Death Note to eliminate criminals. What is the profession of L, the genius detective investigating Kira?",
    id: 86,
    options: ["Detective", "Lawyer", "Doctor", "News Reporter"],
    answer: "Detective",
  },
  {
    question:
      "In 'Noragami,' what is the name of Yato's shinki (regalia) who has taken on a human form?",
    id: 87,
    options: ["Yukine", "Kazuma", "Nora", "Aiha"],
    answer: "Yukine",
  },
  {
    question:
      "In 'Dragon Ball Super,' who is the God of Destruction of Universe 6?",
    id: 88,
    options: ["Beerus", "Champa", "Whis", "Goku"],
    answer: "Champa",
  },
  {
    question:
      "The manga 'Berserk' follows Guts on his quest for revenge. What is the name of the demonic creature who aids Guts?",
    id: 89,
    options: ["Slasher", "Void", "Puck", "Schierke"],
    answer: "Puck",
  },
  {
    question:
      "In 'Death Note,' what is the true name of the Shinigami who first owned the Death Note?",
    id: 90,
    options: ["Ryuk", "Rem", "Shinigami", "Misa"],
    answer: "Ryuk",
  },
  {
    question:
      "Which manga series follows the adventures of Monkey D. Luffy and his crew as they search for the legendary treasure 'One Piece'?",
    id: 91,
    options: ["Bleach", "One Piece", "Naruto", "Fairy Tail"],
    answer: "One Piece",
  },
  {
    question:
      "In 'My Hero Academia,' who is known as the 'Symbol of Peace' and is the number one hero?",
    id: 92,
    options: ["Endeavor", "Hawks", "All Might", "Best Jeanist"],
    answer: "All Might",
  },
  {
    question: "In 'Naruto,' who is the leader of the Akatsuki organization?",
    id: 93,
    options: ["Itachi Uchiha", "Pain (Nagato)", "Sasori", "Kisame Hoshigaki"],
    answer: "Pain (Nagato)",
  },
  {
    question:
      "'Attack on Titan' follows Eren Yeager's fight against Titans. What is the name of the mysterious power that allows Eren to transform into a Titan?",
    id: 94,
    options: ["Titan Mode", "Shift Power", "Titan Shifting", "Eldian Form"],
    answer: "Titan Shifting",
  },
  {
    question:
      "In 'Tokyo Ghoul,' what is the name of the organization that aims to eradicate ghouls?",
    id: 95,
    options: ["Anteiku", "Gourmet Corp", "Aogiri Tree", "C.C.G."],
    answer: "C.C.G.",
  },
  {
    question:
      "The protagonist of 'Dragon Ball Z' is Gohan. What is his father's Saiyan name?",
    id: 96,
    options: ["Vegeta", "Raditz", "Goku", "Bardock"],
    answer: "Goku",
  },
  {
    question:
      "'Fullmetal Alchemist' follows two brothers who use alchemy in their quest to find the Philosopher's Stone. What's the name of the alchemical energy source?",
    id: 97,
    options: ["Ether", "Mana", "Prana", "Tectum"],
    answer: "Prana",
  },
  {
    question:
      "In the manga 'Hunter x Hunter,' which character is the assassin who hails from the Zoldyck family?",
    id: 98,
    options: [
      "Gon Freecss",
      "Killua Zoldyck",
      "Leorio Paradinight",
      "Kurapika",
    ],
    answer: "Killua Zoldyck",
  },
  {
    question:
      "'One Punch Man' features a cyborg hero who seeks revenge on the mad scientist who transformed him. What is the name of the Hero Association's top-ranked hero?",
    id: 99,
    options: ["Genos", "Mumen Rider", "Bang", "Blast"],
    answer: "Blast",
  },
  {
    question:
      "In 'Black Clover,' what is the name of the magical kingdom where Asta and Yuno are from?",
    id: 100,
    options: [
      "Clover Kingdom",
      "Spade Kingdom",
      "Diamond Kingdom",
      "Heart Kingdom",
    ],
    answer: "Clover Kingdom",
  },
];
